var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('core-grid',{ref:"grid",attrs:{"onRead":_vm.onRead,"schema":_vm.schema}}),_c('EmailTemplateAddEdit',{ref:"editar",on:{"close":_vm.response}}),_c('EmailTemplateDetails',{ref:"templateDetails",on:{"close":_vm.response}}),_c('EmailTemplateHtmlBody',{ref:"templateHtmlBody",on:{"close":_vm.response}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }